import React, { MouseEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import * as Bridge from '@/api/BridgeApi'
import { TOP_NATIVE_ROUTES } from '@/domains/CommonDomain'
import { useBackButton } from '@/hooks/useBackButton'
import { useTrans } from '@/hooks/useTrans'
import { IRootState } from '@/modules'
import { ERROR, errorActions, IErrorState } from '@/modules/common/error'
import { goBack } from '@/utils/historyUtils'

import { FlexBox } from '../box/FlexBox'
import { CONTAINER_STYLE, MainContainer } from '../container/MainContainer'

interface IFullPageErrorProps {
  isPathError?: boolean
}

export const FullPageError = (props: IFullPageErrorProps) => {
  const $ = useTrans()
  const dispatch = useDispatch()

  const { isPathError = false } = props
  const { errorCode } = useSelector<IRootState, IErrorState>(state => state[ERROR])
  const message = isPathError ? $('common_error_path_desc') : $('common_error_server_desc')

  const onClickButton = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    if (isPathError) {
      dispatch(errorActions.resolve())
      goBack()

      return
    }

    Bridge.navigateTo(TOP_NATIVE_ROUTES.ROOT)
  }

  useBackButton(() => {})

  return (
    <MainContainer style={CONTAINER_STYLE.NO_MARGIN}>
      <FlexBox isCenter>
        <div className="err">
          <span className="err__img err__img--error" />
          <p className="err__dsc err__dsc--bigger">{message}</p>
          {isPathError ? <></> : <p className="err__code">Code : {errorCode}</p>}
        </div>
      </FlexBox>
      <div className="err__btn">
        <a href="\#" className="btn btn--gr btn--large" onClick={onClickButton}>
          {$('common_ok_button')}
        </a>
      </div>
    </MainContainer>
  )
}
